export default function TitleService($document, $translate, $rootScope, $filter) {
	"ngInject";

	const $doc = $document[0],
		separator = " | ",
		orgTranslate = $filter("orgTranslate");

	let baseTitle = $doc.title,
		current = null;

	$rootScope.$on("$translateChangeSuccess", function () {
		baseTitle = $translate.instant("pros-maps.app.title");
	});

	$rootScope.$on("$stateChangeSuccess", () => {
		titleService.reset();
	});

	const titleService = {
		getTitle: () => (
			current
		),
		setTitle: (title) => {
			current = title || null;
			setTimeout(() => {
				$doc.title = (current ? current + separator : "") + baseTitle;
			});
		},
		setTitleTranslate: (key, values) => {
			let title = $translate.instant(key, values);
			titleService.setTitle(title);
		},
		setTitleOrg: (org) => {
			let title = `${org.name} ${orgTranslate(org.type)}`;
			titleService.setTitle(title);
		},
		reset: () => {
			titleService.setTitle();
		}
	};
	return titleService;
}
